var _rect, _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _g4, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlayBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "artwork",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "135px",
    height: "40px",
    viewBox: "0 0 135 40",
    enableBackground: "new 0 0 135 40",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: -10,
    fill: "#FFFFFF",
    fillOpacity: 0,
    width: 155,
    height: 60
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M130,40H5c-2.75,0-5-2.25-5-5V5c0-2.75,2.25-5,5-5h125c2.75,0,5,2.25,5,5v30C135,37.75,132.75,40,130,40z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A6A6A6",
    d: "M130,0.8c2.316,0,4.2,1.884,4.2,4.2v30c0,2.316-1.884,4.2-4.2,4.2H5c-2.316,0-4.2-1.884-4.2-4.2V5 c0-2.316,1.884-4.2,4.2-4.2H130 M130,0H5C2.25,0,0,2.25,0,5v30c0,2.75,2.25,5,5,5h125c2.75,0,5-2.25,5-5V5 C135,2.25,132.75,0,130,0L130,0z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    d: "M47.418,10.243 c0,0.838-0.248,1.505-0.745,2.003c-0.564,0.592-1.3,0.888-2.204,0.888c-0.866,0-1.603-0.3-2.208-0.9 c-0.606-0.601-0.909-1.345-0.909-2.233c0-0.889,0.303-1.633,0.909-2.233c0.605-0.601,1.342-0.901,2.208-0.901 c0.43,0,0.841,0.084,1.231,0.251c0.391,0.168,0.704,0.391,0.938,0.67l-0.527,0.528c-0.397-0.475-0.944-0.712-1.643-0.712 c-0.632,0-1.178,0.222-1.639,0.666C42.369,8.714,42.139,9.29,42.139,10s0.23,1.286,0.691,1.731 c0.461,0.444,1.007,0.666,1.639,0.666c0.67,0,1.229-0.223,1.676-0.67c0.29-0.291,0.458-0.696,0.503-1.215h-2.179V9.79h2.907 C47.405,9.947,47.418,10.098,47.418,10.243z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    d: "M52.028,7.737h-2.732v1.902h2.464v0.721 h-2.464v1.902h2.732V13h-3.503V7h3.503V7.737z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    d: "M55.279,13h-0.772V7.737h-1.676V7h4.123 v0.737h-1.676V13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    d: "M59.938,13V7h0.771v6H59.938z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    d: "M64.128,13h-0.772V7.737h-1.676V7h4.123 v0.737h-1.676V13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    d: "M73.609,12.224 c-0.59,0.607-1.323,0.909-2.2,0.909c-0.877,0-1.61-0.303-2.199-0.909c-0.59-0.606-0.884-1.348-0.884-2.225 s0.294-1.619,0.884-2.225c0.589-0.607,1.322-0.91,2.199-0.91c0.872,0,1.604,0.305,2.196,0.914 c0.592,0.609,0.888,1.349,0.888,2.221C74.493,10.877,74.198,11.619,73.609,12.224z M69.779,11.722 c0.444,0.45,0.987,0.674,1.63,0.674c0.643,0,1.186-0.225,1.63-0.674c0.444-0.45,0.667-1.024,0.667-1.722s-0.223-1.273-0.667-1.722 c-0.443-0.45-0.987-0.674-1.63-0.674c-0.643,0-1.186,0.225-1.63,0.674c-0.443,0.45-0.666,1.024-0.666,1.722 S69.336,11.272,69.779,11.722z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    d: "M75.575,13V7h0.938l2.916,4.668h0.033 l-0.033-1.156V7h0.771v6h-0.805l-3.051-4.894h-0.033l0.033,1.156V13H75.575z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M68.136,21.751c-2.352,0-4.269,1.788-4.269,4.253c0,2.449,1.917,4.253,4.269,4.253 c2.352,0,4.269-1.804,4.269-4.253C72.405,23.54,70.488,21.751,68.136,21.751z M68.136,28.582c-1.289,0-2.401-1.063-2.401-2.578 c0-1.531,1.112-2.578,2.401-2.578c1.289,0,2.4,1.047,2.4,2.578C70.536,27.519,69.425,28.582,68.136,28.582z M58.822,21.751 c-2.352,0-4.269,1.788-4.269,4.253c0,2.449,1.917,4.253,4.269,4.253c2.352,0,4.269-1.804,4.269-4.253 C63.092,23.54,61.174,21.751,58.822,21.751z M58.822,28.582c-1.289,0-2.4-1.063-2.4-2.578c0-1.531,1.112-2.578,2.4-2.578 c1.289,0,2.4,1.047,2.4,2.578C61.223,27.519,60.111,28.582,58.822,28.582z M47.744,23.056v1.804h4.318 c-0.129,1.015-0.467,1.756-0.983,2.272c-0.628,0.628-1.611,1.321-3.335,1.321c-2.658,0-4.736-2.143-4.736-4.801 s2.078-4.801,4.736-4.801c1.434,0,2.481,0.564,3.254,1.289l1.273-1.273c-1.079-1.031-2.513-1.821-4.527-1.821 c-3.641,0-6.702,2.964-6.702,6.605c0,3.641,3.061,6.605,6.702,6.605c1.965,0,3.448-0.644,4.608-1.853 c1.192-1.192,1.563-2.868,1.563-4.221c0-0.419-0.032-0.806-0.097-1.128H47.744z M93.052,24.458 c-0.354-0.951-1.434-2.707-3.641-2.707c-2.191,0-4.011,1.724-4.011,4.253c0,2.384,1.804,4.253,4.221,4.253 c1.949,0,3.077-1.192,3.544-1.885l-1.45-0.967c-0.483,0.709-1.144,1.176-2.094,1.176c-0.951,0-1.627-0.435-2.062-1.289l5.687-2.352 L93.052,24.458z M87.252,25.876c-0.048-1.643,1.273-2.481,2.223-2.481c0.741,0,1.369,0.371,1.579,0.902L87.252,25.876z M82.628,30 h1.869V17.498h-1.869V30z M79.567,22.702h-0.064c-0.419-0.499-1.224-0.951-2.239-0.951c-2.127,0-4.076,1.869-4.076,4.269 c0,2.384,1.949,4.237,4.076,4.237c1.015,0,1.82-0.451,2.239-0.967h0.064v0.612c0,1.627-0.87,2.497-2.272,2.497 c-1.144,0-1.853-0.822-2.143-1.514l-1.627,0.677c0.467,1.128,1.708,2.513,3.77,2.513c2.191,0,4.044-1.289,4.044-4.43v-7.636h-1.772 V22.702z M77.425,28.582c-1.289,0-2.368-1.079-2.368-2.562c0-1.498,1.079-2.594,2.368-2.594c1.273,0,2.271,1.095,2.271,2.594 C79.696,27.503,78.698,28.582,77.425,28.582z M101.806,17.499h-4.471V30H99.2v-4.736h2.605c2.068,0,4.101-1.497,4.101-3.882 S103.874,17.499,101.806,17.499z M101.854,23.524H99.2v-4.285h2.654c1.395,0,2.187,1.155,2.187,2.143 C104.041,22.35,103.249,23.524,101.854,23.524z M113.386,21.729c-1.351,0-2.75,0.595-3.329,1.914l1.657,0.692 c0.354-0.692,1.013-0.917,1.705-0.917c0.965,0,1.946,0.579,1.962,1.608v0.129c-0.338-0.193-1.062-0.483-1.946-0.483 c-1.785,0-3.603,0.981-3.603,2.815c0,1.673,1.464,2.75,3.104,2.75c1.255,0,1.946-0.563,2.38-1.222h0.064v0.965h1.801v-4.793 C117.181,22.967,115.525,21.729,113.386,21.729z M113.16,28.58c-0.611,0-1.464-0.306-1.464-1.062c0-0.965,1.062-1.335,1.978-1.335 c0.82,0,1.206,0.177,1.705,0.418C115.235,27.76,114.238,28.58,113.16,28.58z M123.743,22.002l-2.139,5.42h-0.064l-2.219-5.42h-2.01 l3.329,7.575l-1.898,4.214h1.946l5.131-11.789H123.743z M106.936,30h1.866V17.499h-1.866V30z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.7996,
    y1: 173.2902,
    x2: 5.0172,
    y2: 156.5078,
    gradientTransform: "matrix(1 0 0 -1 0 181.9998)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    style: {
      stopColor: "#00A1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    style: {
      stopColor: "#00BEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#00D2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    style: {
      stopColor: "#00DFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E3FF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M10.435,7.538c-0.291,0.308-0.463,0.786-0.463,1.405v22.116c0,0.62,0.172,1.097,0.463,1.405 l0.074,0.072l12.389-12.389v-0.146v-0.146L10.509,7.465L10.435,7.538z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.8343,
    y1: 161.9984,
    x2: 9.6374,
    y2: 161.9984,
    gradientTransform: "matrix(1 0 0 -1 0 181.9998)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    style: {
      stopColor: "#FFBD00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#FFA500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9C00"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M27.028,24.278l-4.129-4.131v-0.146v-0.146l4.13-4.13l0.093,0.053l4.893,2.78 c1.398,0.794,1.398,2.093,0,2.888l-4.893,2.78L27.028,24.278z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.8269,
    y1: 159.7038,
    x2: 2.0686,
    y2: 136.9455,
    gradientTransform: "matrix(1 0 0 -1 0 181.9998)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF3A44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C31162"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M27.122,24.225l-4.223-4.224L10.435,32.464c0.461,0.488,1.221,0.548,2.078,0.061L27.122,24.225"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.2972,
    y1: 181.8237,
    x2: 17.4598,
    y2: 171.6612,
    gradientTransform: "matrix(1 0 0 -1 0 181.9998)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#32A071"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    style: {
      stopColor: "#2DA771"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    style: {
      stopColor: "#15CF74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    style: {
      stopColor: "#06E775"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00F076"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M27.122,15.777l-14.608-8.3c-0.857-0.487-1.617-0.426-2.078,0.061l12.463,12.463L27.122,15.777z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    enableBackground: "new    ",
    d: "M27.029,24.132l-14.515,8.247c-0.812,0.461-1.538,0.431-2.004,0.011l0,0 l-0.075,0.074l0,0l0.074,0.072l0,0c0.466,0.42,1.192,0.451,2.004-0.011l14.608-8.3L27.029,24.132z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    enableBackground: "new    ",
    d: "M10.435,32.318c-0.291-0.308-0.463-0.786-0.463-1.405v0.146 c0,0.619,0.172,1.097,0.463,1.405l0.075-0.074L10.435,32.318z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    enableBackground: "new    ",
    d: "M32.015,21.299l-4.986,2.833l0.093,0.093l4.893-2.78 c0.699-0.397,1.048-0.92,1.048-1.443l0,0C33.004,20.474,32.648,20.939,32.015,21.299z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    d: "M12.513,7.623l19.501,11.08 c0.634,0.36,0.989,0.824,1.048,1.298l0,0c0-0.523-0.349-1.047-1.048-1.444L12.513,7.477c-1.398-0.794-2.541-0.135-2.541,1.466 v0.146C9.972,7.489,11.116,6.829,12.513,7.623z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBadge);
export default __webpack_public_path__ + "static/media/google-play-badge.2cd00fcc3cebf9d5f15cfd0aa769f740.svg";
export { ForwardRef as ReactComponent };